export enum PaymentMethod {
    creditCard = 'CARD',
    directDebit = 'ACH',
}

export interface TaxesResponse {
    totalTaxes: number;
}

export interface IAdyenSession {
    sessionId: string;
    sessionData: string;
}
